/* eslint-disable indent */
/* eslint-disable no-console */
import { useCallback, useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { getIntermediarios, getClientes, getEdificios } from "../../utils";
import "./stylesListadoFacturas.scss";

export const ListadoFacturas = ({
  facturas,
  pantallasEdificio,
  comisionEdificio_1_porcentaje,
  comisionEdificio_1_fechainicio,
  comisionEdificio_1_fechafin,
  comisionEdificio_2_porcentaje,
  comisionEdificio_2_fechainicio,
  comisionEdificio_2_fechafin,
  comisionEdificio_3_porcentaje,
  comisionEdificio_3_fechainicio,
  comisionEdificio_3_fechafin,
  edificioId = null,
  pais,
}) => {
  const [intermediarios, setIntermediarios] = useState([]);
  const [orden] = useState({ campo: "fechafactura", ascendente: true });
  const [totales, setTotales] = useState({
    facturado: 0,
    comision: 0,
    comisionCobrada: 0,
    totalImporte: 0,
    totalComisionIntermediario: 0,
  });
  const [clientes, setClientes] = useState([]);
  const [edificios, setEdificios] = useState([]);

  const localString = useCallback(
    (pais) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
      })[pais] || "es-UY",
    []
  );

  const moneda = useCallback(
    (pais) =>
      ({
        Chile: "$ ",
        Perú: "S/ ",
        Uruguay: "$ ",
      })[pais] || "$ ",
    []
  );

  const decimales = useCallback(
    (pais) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[pais] || 0,
    []
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [intermediariosData, clientesData, edificiosData] = await Promise.all([
          getIntermediarios(),
          getClientes({ pais }),
          getEdificios({ pais }),
        ]);
        setIntermediarios(intermediariosData || []);
        setClientes(clientesData || []);
        setEdificios(edificiosData || []);
      } catch (error) {
        toast.error(`Error al cargar datos: ${error.message}`);
      }
    };

    fetchData();
  }, [pais]);

  const getFacturadoYComisionNuevo = useCallback(
    (
      importe,
      clienteNombre,
      pantallasEdificio,
      pantallastotales,
      facturafecha,
      pantallas_ascensores,
      pantallas_espera,
      pantallas_circulacion,
      pantallas_cowork,
      edificiosUnicos,
      isBTL,
      comisionDirecta
    ) => {
      if (isBTL) {
        const comisionEdificioPorcentaje = comisionDirecta;
        const participacionEdificioPlata = importe;
        const comisionEdificio = participacionEdificioPlata * (comisionEdificioPorcentaje / 100);

        return {
          facturado: importe,
          comision: comisionEdificio,
          comisionIntermediarioValor: 0,
          comisionIntermediarioPorcentaje: 0,
          intermediarioNombre: "-",
          pantallasEdificioAjustadas: 0,
        };
      }

      let comisionEdificioPorcentaje;

      const fechaInicio1 = new Date(comisionEdificio_1_fechainicio);
      const fechaFin1 = new Date(comisionEdificio_1_fechafin);
      const fechaInicio2 = new Date(comisionEdificio_2_fechainicio);
      const fechaFin2 = new Date(comisionEdificio_2_fechafin);
      const fechaInicio3 = new Date(comisionEdificio_3_fechainicio);
      const fechaFin3 = new Date(comisionEdificio_3_fechafin);

      if (facturafecha >= fechaInicio1 && facturafecha <= fechaFin1) {
        comisionEdificioPorcentaje = comisionEdificio_1_porcentaje;
      } else if (facturafecha >= fechaInicio2 && facturafecha <= fechaFin2) {
        comisionEdificioPorcentaje = comisionEdificio_2_porcentaje;
      } else if (facturafecha >= fechaInicio3 && facturafecha <= fechaFin3) {
        comisionEdificioPorcentaje = comisionEdificio_3_porcentaje;
      } else {
        comisionEdificioPorcentaje = 0;
      }

      if (!clienteNombre || clientes.length === 0) {
        return {
          facturado: 0,
          comision: 0,
          comisionIntermediarioValor: 0,
          comisionIntermediarioPorcentaje: 0,
          intermediarioNombre: "SIN INTERMEDIARIO",
          pantallasEdificioAjustadas: 0,
        };
      }

      const clienteEncontrado = clientes.find(
        (c) => c.nombre.toLowerCase() === clienteNombre.toLowerCase() && c.pais === pais
      );

      let comisionIntermediario = 0;
      let intermediarioNombre = "SIN INTERMEDIARIO";

      if (clienteEncontrado && clienteEncontrado.agencia) {
        const intermediarioEncontrado = intermediarios.find(
          (i) => i.id === clienteEncontrado.agencia && i.pais === pais
        );
        if (intermediarioEncontrado) {
          intermediarioNombre = intermediarioEncontrado.nombre;
          const fechaFacturaValida = facturafecha && !isNaN(new Date(facturafecha).getTime());
          const anoFactura = fechaFacturaValida ? new Date(facturafecha).getFullYear() : new Date().getFullYear();
          if (
            intermediarioEncontrado.comision_2 !== null &&
            intermediarioEncontrado.comision_2_fechainicio &&
            intermediarioEncontrado.comision_2_fechafin
          ) {
            const fechaInicioIntermediario = new Date(intermediarioEncontrado.comision_2_fechainicio);
            const fechaFinIntermediario = new Date(intermediarioEncontrado.comision_2_fechafin);
            const anoInicioIntermediario = fechaInicioIntermediario.getFullYear();
            const anoFinIntermediario = fechaFinIntermediario.getFullYear();

            comisionIntermediario =
              anoFactura >= anoInicioIntermediario && anoFactura <= anoFinIntermediario
                ? intermediarioEncontrado.comision_2 || 0
                : intermediarioEncontrado.comision || 0;
          } else {
            comisionIntermediario = intermediarioEncontrado.comision || 0;
          }
        }
      }

      const comisionIntermediarioValor = importe * (comisionIntermediario / 100);
      const inversionNeta = importe - comisionIntermediarioValor;

      let pantallasEdificioAjustadas = pantallasEdificio;

      if (edificioId) {
        const edificioActual = edificios.find((e) => e.id === edificioId);
        if (!edificioActual) {
          toast.error("No se encontró el edificio seleccionado");
          return {
            facturado: 0,
            comision: 0,
            comisionIntermediarioValor: 0,
            comisionIntermediarioPorcentaje: 0,
            intermediarioNombre: "SIN INTERMEDIARIO",
            pantallasEdificioAjustadas: 0,
          };
        }

        const circuitosVacios =
          !pantallas_ascensores && !pantallas_espera && !pantallas_circulacion && !pantallas_cowork;

        if (circuitosVacios) {
          const pantallasAscensores = edificioActual.pantallas || 0;
          const pantallasEspera = edificioActual.espera || 0;
          const pantallasCirculacion = edificioActual.totems || 0;
          const pantallasCowork = edificioActual.cowork || 0;
          pantallasEdificioAjustadas = pantallasAscensores + pantallasEspera + pantallasCirculacion + pantallasCowork;
        } else {
          let totalPantallas = 0;
          const edificioIdStr = String(edificioId);

          if (pantallas_ascensores && pantallas_ascensores.split(",").includes(edificioIdStr)) {
            totalPantallas += edificioActual.pantallas || 0;
          }
          if (pantallas_espera && pantallas_espera.split(",").includes(edificioIdStr)) {
            totalPantallas += edificioActual.espera || 0;
          }
          if (pantallas_circulacion && pantallas_circulacion.split(",").includes(edificioIdStr)) {
            totalPantallas += edificioActual.totems || 0;
          }
          if (pantallas_cowork && pantallas_cowork.split(",").includes(edificioIdStr)) {
            totalPantallas += edificioActual.cowork || 0;
          }

          pantallasEdificioAjustadas = totalPantallas;

          if (totalPantallas === 0) {
            pantallasEdificioAjustadas = 0;
          }
        }
      } else {
        pantallasEdificioAjustadas = pantallasEdificio;
      }

      const participacionEdificioPorcentaje = pantallastotales > 0 ? pantallasEdificioAjustadas / pantallastotales : 0;
      const participacionEdificioPlata = participacionEdificioPorcentaje * inversionNeta;
      const comisionEdificio = participacionEdificioPlata * (comisionEdificioPorcentaje / 100);

      return {
        facturado: participacionEdificioPlata,
        comision: comisionEdificio,
        comisionIntermediarioValor: participacionEdificioPorcentaje * comisionIntermediarioValor,
        comisionIntermediarioPorcentaje: comisionIntermediario,
        intermediarioNombre,
        pantallasEdificioAjustadas,
      };
    },
    [
      clientes,
      intermediarios,
      comisionEdificio_1_porcentaje,
      comisionEdificio_1_fechainicio,
      comisionEdificio_1_fechafin,
      comisionEdificio_2_porcentaje,
      comisionEdificio_2_fechainicio,
      comisionEdificio_2_fechafin,
      comisionEdificio_3_porcentaje,
      comisionEdificio_3_fechainicio,
      comisionEdificio_3_fechafin,
      pais,
      edificios,
    ]
  );

  const facturasOrdenadas = useMemo(
    () =>
      [...facturas].sort((a, b) => {
        const fechaA = new Date(a.facturafecha);
        const fechaB = new Date(b.facturafecha);
        return orden.ascendente ? fechaA - fechaB : fechaB - fechaA;
      }),
    [facturas, orden.ascendente]
  );

  useEffect(() => {
    if (clientes.length === 0) return;

    const newTotales = {
      facturado: 0,
      comision: 0,
      comisionCobrada: 0,
      totalImporte: 0,
      totalComisionIntermediario: 0,
    };
    facturasOrdenadas.forEach(
      ({
        importe,
        cliente,
        pantallastotales,
        facturafechacobro,
        facturafecha,
        pantallas_ascensores,
        pantallas_espera,
        pantallas_circulacion,
        pantallas_cowork,
        edificiosUnicos,
        isBTL,
        comision: comisionDirecta,
      }) => {
        const { facturado, comision, comisionIntermediarioValor, pantallasEdificioAjustadas } =
          getFacturadoYComisionNuevo(
            importe,
            cliente,
            pantallasEdificio,
            pantallastotales,
            new Date(facturafecha),
            pantallas_ascensores,
            pantallas_espera,
            pantallas_circulacion,
            pantallas_cowork,
            edificiosUnicos,
            isBTL,
            comisionDirecta
          );

        newTotales.facturado += facturado;
        newTotales.comision += isBTL ? (importe * comisionDirecta) / 100 : comision;
        newTotales.totalImporte += isBTL ? importe : (pantallasEdificioAjustadas / pantallastotales) * importe;
        newTotales.totalComisionIntermediario += comisionIntermediarioValor;

        if (facturafechacobro) {
          newTotales.comisionCobrada += isBTL ? (importe * comisionDirecta) / 100 : comision;
        }
      }
    );

    setTotales(newTotales);
  }, [facturasOrdenadas, getFacturadoYComisionNuevo, pantallasEdificio, clientes]);

  return (
    <div className="table-responsive">
      {clientes.length === 0 || edificios.length === 0 ? (
        <p>Cargando datos...</p>
      ) : (
        <table className="table table-fixed table-striped table-bordered table-hover">
          <colgroup>
            <col /> {/* TIPO */}
            <col /> {/* NÚMERO FACTURA */}
            <col /> {/* FECHA FACTURA */}
            <col /> {/* CLIENTE */}
            <col /> {/* PANTALLAS PARTICIPANTES */}
            <col /> {/* PARTICIPACIÓN EDIFICIO */}
            <col /> {/* IMPORTE BRUTO */}
            <col /> {/* INTERMEDIARIO */}
            <col /> {/* COMISIÓN INTERMEDIACIÓN */}
            <col /> {/* IMPORTE NETO */}
            <col /> {/* COMISIÓN EDIFICIO (%) */}
            <col /> {/* COMISIÓN EDIFICIO (IMPORTE) */}
            <col /> {/* COBRADA */}
          </colgroup>

          <thead className="text-center align-middle">
            <tr>
              <th className="tipo">TIPO</th>
              <th className="numero-factura">NÚMERO FACTURA</th>
              <th className="fecha-factura">FECHA FACTURA</th>
              <th className="cliente">CLIENTE</th>
              <th className="pantallas-participantes">PANTALLAS PARTICIPANTES</th>
              <th className="pantallas-involucradas">PARTICIPACIÓN EDIFICIO</th>
              <th className="importe-bruto">IMPORTE BRUTO</th>
              <th className="intermediario">INTERMEDIARIO</th>
              <th className="comision-intermediario">COMISIÓN</th>
              <th className="importe-neto">IMPORTE NETO</th>
              <th className="comision-edificio" colSpan="2">
                COMISIÓN EDIFICIO
              </th>
              <th className="cobrada">COBRADA</th>
            </tr>
          </thead>

          <tbody>
            {facturasOrdenadas.map(
              ({
                cliente,
                facturafecha,
                facturafechacobro,
                facturanumero,
                id,
                importe,
                pantallastotales,
                edificiosUnicos,
                pantallas_ascensores,
                pantallas_espera,
                pantallas_circulacion,
                pantallas_cowork,
                isBTL,
                comision,
                plazocobro,
              }) => {
                const {
                  facturado,
                  comision: comisionCalculada,
                  comisionIntermediarioPorcentaje,
                  intermediarioNombre,
                  pantallasEdificioAjustadas,
                } = getFacturadoYComisionNuevo(
                  importe,
                  cliente,
                  pantallasEdificio,
                  pantallastotales,
                  new Date(facturafecha),
                  pantallas_ascensores,
                  pantallas_espera,
                  pantallas_circulacion,
                  pantallas_cowork,
                  edificiosUnicos,
                  isBTL,
                  comision
                );

                return (
                  <tr className="table-striped" key={id}>
                    <td className="text-center">{isBTL ? "BTL" : "PAUTA"}</td>
                    <td className="text-center">{facturanumero}</td>
                    <td className="text-center">
                      {`${new Date(facturafecha).getUTCDate().toString().padStart(2, "0")}/${(new Date(facturafecha).getUTCMonth() + 1).toString().padStart(2, "0")}/${new Date(facturafecha).getUTCFullYear().toString().slice(-2)}`}
                    </td>
                    <td className="text-center">{cliente}</td>
                    <td className="text-center">{isBTL ? "-" : pantallastotales}</td>
                    <td className="text-center">
                      {isBTL
                        ? "-"
                        : Number((pantallasEdificioAjustadas / pantallastotales) * 100).toLocaleString(
                            localString(pais),
                            {
                              minimumFractionDigits: decimales(pais),
                              maximumFractionDigits: decimales(pais),
                            }
                          ) + "%"}
                    </td>
                    <td className="text-end">{`${moneda(pais)} ${(isBTL
                      ? importe
                      : (pantallasEdificioAjustadas / pantallastotales) * importe
                    ).toLocaleString(localString(pais), {
                      minimumFractionDigits: decimales(pais),
                      maximumFractionDigits: decimales(pais),
                    })}`}</td>
                    <td className="text-center">{intermediarioNombre}</td>
                    <td className="text-center">
                      {comisionIntermediarioPorcentaje > 0 ? `${comisionIntermediarioPorcentaje}%` : "-"}
                    </td>
                    <td className="text-end">{`${moneda(pais)} ${facturado.toLocaleString(localString(pais), {
                      minimumFractionDigits: decimales(pais),
                      maximumFractionDigits: decimales(pais),
                    })}`}</td>
                    <td className="text-center">
                      {isBTL
                        ? `${comision.toLocaleString(localString(pais), {
                            minimumFractionDigits: decimales(pais),
                            maximumFractionDigits: decimales(pais),
                          })}%`
                        : (() => {
                            const fechaFactura = new Date(facturafecha);
                            const fechaInicio1 = new Date(comisionEdificio_1_fechainicio);
                            const fechaFin1 = new Date(comisionEdificio_1_fechafin);
                            const fechaInicio2 = new Date(comisionEdificio_2_fechainicio);
                            const fechaFin2 = new Date(comisionEdificio_2_fechafin);
                            const fechaInicio3 = new Date(comisionEdificio_3_fechainicio);
                            const fechaFin3 = new Date(comisionEdificio_3_fechafin);

                            if (fechaFactura >= fechaInicio1 && fechaFactura <= fechaFin1) {
                              return `${comisionEdificio_1_porcentaje}%`;
                            } else if (fechaFactura >= fechaInicio2 && fechaFactura <= fechaFin2) {
                              return `${comisionEdificio_2_porcentaje}%`;
                            } else if (fechaFactura >= fechaInicio3 && fechaFactura <= fechaFin3) {
                              return `${comisionEdificio_3_porcentaje}%`;
                            } else {
                              return "0%";
                            }
                          })()}
                    </td>
                    <td className="text-end">{`${moneda(pais)} ${comisionCalculada.toLocaleString(localString(pais), {
                      minimumFractionDigits: decimales(pais),
                      maximumFractionDigits: decimales(pais),
                    })}`}</td>
                    <td
                      className="text-center"
                      style={{ backgroundColor: facturafechacobro ? "#198754" : "#dc3545", color: "white" }}
                    >
                      {facturafechacobro && !isNaN(new Date(facturafechacobro).getTime())
                        ? `${new Date(facturafechacobro).getUTCDate().toString().padStart(2, "0")}/${(new Date(facturafechacobro).getUTCMonth() + 1).toString().padStart(2, "0")}/${new Date(facturafechacobro).getUTCFullYear().toString().slice(-2)}`
                        : plazocobro && !isNaN(new Date(plazocobro).getTime())
                          ? `${new Date(plazocobro).getUTCDate().toString().padStart(2, "0")}/${(new Date(plazocobro).getUTCMonth() + 1).toString().padStart(2, "0")}/${new Date(plazocobro).getUTCFullYear().toString().slice(-2)}`
                          : "Pendiente"}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>

          <tfoot>
            <tr className="table-dark">
              <td colSpan="6" className="text-start">
                TOTALES DEL PERÍODO SELECCIONADO
              </td>
              <td className="text-end">
                {moneda(pais)}
                {(totales.totalImporte || 0).toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}
              </td>
              <td className="text-center" /> {/* INTERMEDIARIO */}
              <td className="text-center">
                {totales.totalImporte
                  ? (100 - (totales.facturado / totales.totalImporte) * 100).toLocaleString(localString(pais), {
                      maximumFractionDigits: 1,
                      minimumFractionDigits: 1,
                    })
                  : "0"}
                %
              </td>
              <td className="text-end">
                {moneda(pais)}
                {(totales.facturado || 0).toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}
              </td>
              <td className="text-center">
                {totales.facturado
                  ? (() => {
                      const porcentaje = (totales.comision / totales.facturado) * 100;
                      const decimales = porcentaje.toFixed(1) % 1 === 0 ? 0 : 1;
                      return porcentaje.toLocaleString(localString(pais), {
                        maximumFractionDigits: decimales,
                        minimumFractionDigits: decimales,
                      });
                    })()
                  : "0"}
                %
              </td>
              <td className="text-end">
                {moneda(pais)}
                {(totales.comision || 0).toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}
              </td>
              <td className="text-end" style={{ backgroundColor: "#198754", color: "white" }}>
                {moneda(pais)}
                {(totales.comisionCobrada || 0).toLocaleString(localString(pais), {
                  maximumFractionDigits: decimales(pais),
                  minimumFractionDigits: decimales(pais),
                })}
              </td>
            </tr>
          </tfoot>
        </table>
      )}
    </div>
  );
};
